import { FC, useContext, useEffect, useRef, useState } from 'react';

import { Button } from '@smartshell/ui-kit';
import cn from 'classnames';

import { LocalizationContext } from 'localization';
import { IShortcutsProps } from 'pages/GameAccounts/interfaces';

import s from './Shortcuts.module.scss';

export const Shortcuts: FC<IShortcutsProps> = ({ shortcuts }) => {
  const { t } = useContext(LocalizationContext);
  const openerRef = useRef<HTMLDivElement>(null);
  const tooltipRef = useRef<HTMLDivElement | null>(null);

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const close = (event: MouseEvent): void => {
      if (
        openerRef.current?.contains(event.target as Node) ||
        tooltipRef.current?.contains(event.target as Node)
      ) {
        return;
      }
      setIsVisible(false);
    };

    document.addEventListener('click', close);
    return () => document.removeEventListener('click', close);
  }, []);

  if (!shortcuts.length) {
    return null;
  }

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent): void => {
      const target = event.target as HTMLElement;

      if (
        !openerRef.current?.contains(target) &&
        !tooltipRef.current?.contains(target)
      ) {
        setIsVisible(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div ref={openerRef} className={s.wrapper}>
      <Button
        variant="ghost"
        className={s.summary}
        onClick={() => setIsVisible((prev) => !prev)}
      >
        {t('shortcuts.count', shortcuts.length)}
      </Button>
      {isVisible && (
        <div
          ref={tooltipRef}
          className={cn(s.list, { [s.visible]: isVisible })}
        >
          <div className={cn(s.item, s.title)}>{t('shortcuts.list')}</div>
          <div className={s['items-container']}>
            {shortcuts.map((sh) => (
              <div key={`shortcuts-${sh.id}`} className={s.item}>
                {sh.title}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
